






















import { Component, Vue, Prop } from 'vue-property-decorator'
import { addAppDeveloper, removeAppDeveloper } from '@/apps/open/services/app'
import { IUser } from '@/apps/open/types'
import AdminSelectorDialogBody from '@/apps/open/components/DialogBodys/AdminSelector.vue'
import { onRequestError } from '@/apps/open/utils'

@Component
export default class DeveloperSetting extends Vue {
  addSubmitLoading = false
  removeSubmitLoading = false
  removeId: any = null

  get appId () {
    return this.$route.params.id
  }

  get selectedIds () {
    return this.developers.map((item: any) => item.userid)
  }

  get isSuperAdmin () {
    return this.$store.getters['isSuperAdmin']
  }

  get developers () {
    return this.$store.getters['App/appDeveloperList']
  }

  async loadDevelopers () {
    this.$store.dispatch('App/GET_APP_INFO', this.appId)
  }

  async addDeveloper (selectedUsers: IUser[]) {
    this.addSubmitLoading = true
    try {
      const ids = selectedUsers.map((item: IUser) => item.id)
      await addAppDeveloper(this.appId, ids.join(','))
      this.$message.success('添加成功')
      this.$dialog.close()
      this.loadDevelopers()
    } catch (error) {
      onRequestError(error, '当前网络异常，请稍后重试')
    }
    this.addSubmitLoading = false
  }

  removeDeveloper (item: any) {
    this.$confirm(
      `确定要移除开发人员 ${item.username} 吗？<br>移除的开发人员将无法参与应用开发等操作`,
      '移除开发人员',
      { dangerouslyUseHTMLString: true }
    ).then(async () => {
      this.removeSubmitLoading = true
      try {
        this.removeId = item.userid
        await removeAppDeveloper(this.appId, item.userid)
        this.$message.success('移除成功')
        this.loadDevelopers()
      } catch (error) {
        let message = '当前网络异常，请稍后重试'
        if (message === 'ids not Exist') {
          message = '开发人员不存在，请勿重复操作'
          this.loadDevelopers()
        }
        onRequestError(error, message)
      }
      this.removeSubmitLoading = false
    })
  }

  async handleAdd () {
    await this.loadDevelopers()
    this.$dialog.show({
      title: '添加开发人员',
      keepAlive: true,
      body: AdminSelectorDialogBody,
      bodyProps: {
        filterRoles: [100],
        selectedIds: this.selectedIds,
        disabledIds: this.selectedIds,
        onCancel: this.$dialog.close,
        onOk: this.addDeveloper
      }
    })
  }
}
